"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function BenefitItem(props) {
    var title = props.title, describe = props.describe, icon = props.icon;
    return (react_1.default.createElement("div", { className: "benefit-item" },
        react_1.default.createElement("div", { className: "benefit-bg", style: { backgroundImage: "url(".concat(icon, ")") } }),
        react_1.default.createElement("div", { className: "benefit-content" },
            react_1.default.createElement("div", { className: "title" }, title),
            react_1.default.createElement("div", { className: "desc" }, describe))));
}
exports.default = BenefitItem;
//# sourceMappingURL=BenefitItem.js.map